export default "__VITE_ASSET__8ae6eb43__"